/* Компонент не пишет ни одного hex и ни одного --p-*. Только роли. */

.text {
  margin: 0;
}

.measure {
  max-width: var(--measure);
  text-wrap: pretty;
}

/* ── Варианты: каждый — одна строка шкалы ─────────────────────────────*/
.v-display-l { font: var(--t-display-l); }
.v-display-m { font: var(--t-display-m); }
.v-title-l   { font: var(--t-title-l); }
.v-title-m   { font: var(--t-title-m); }
.v-title-s   { font: var(--t-title-s); }
.v-body-l    { font: var(--t-body-l); }
.v-body-m    { font: var(--t-body-m); }
.v-body-s    { font: var(--t-body-s); }
.v-label-l   { font: var(--t-label-l); }
.v-label-m   { font: var(--t-label-m); }
.v-caption   { font: var(--t-caption); }

.v-overline {
  font: var(--t-overline);
  letter-spacing: var(--tracking-overline);
  text-transform: uppercase;
}

/* Цифры выравниваются в колонку: баланс и стрик не должны дёргаться
   при смене значения. */
.v-numeric-l {
  font: var(--t-numeric-l);
  font-variant-numeric: tabular-nums;
}

.v-numeric-m {
  font: var(--t-numeric-m);
  font-variant-numeric: tabular-nums;
}

/* ── Тон ──────────────────────────────────────────────────────────────*/
.t-primary   { color: var(--c-text-primary); }
.t-secondary { color: var(--c-text-secondary); }
.t-tertiary  { color: var(--c-text-tertiary); }
.t-accent    { color: var(--c-accent); }
.t-danger    { color: var(--c-danger); }

/* Золото. Никогда не кликается — если этот тон оказался на кнопке,
   что-то пошло не так. */
.t-sacred { color: var(--c-sacred-bright); }
